import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { createTask, updateTask } from '../../actions'
import { Map, List, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox, Popup, Dropdown } from 'semantic-ui-react'
import { connectForm, Form, Field, Submit, Reference } from '~/form'
import { SubeditorArea } from '~/common/subeditor'
import { DateButton } from '~/form/components/Date'
import { ReferenceButton } from '~/form/components/Reference'
import moment from 'moment'

import TaskAdd from '~/task/views/add'
import TaskEdit from '~/task/views/edit'

const statusLabels = {
  pending: 'Odottaa',
  working: 'Työn alla',
  completed: 'Valmis',
}

class ProjectEditorTasks extends Component {
  render() {
    let { project, interview, updateTask, adding, editing, addTask, editTask, viewOnly = false } = this.props

    let tasks = interview.get('tasks', List())
    let interviewId = interview.get('id')
    let projectId = interview.get('project_id')

    let editingTask = editing ? tasks.find(t => t.get('id') === editing) : false

    return (
      <SubeditorArea>
        <Table selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Tehtävä" />
              <Table.HeaderCell content="Henkilö" />
              <Table.HeaderCell content="Deadline" />
              <Table.HeaderCell content="Status" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tasks.size ? (
              tasks.map(task => {
                let id = task.get('id')
                let status = task.get('status')
                let deadline = task.get('deadline') ? moment(task.get('deadline'), 'YYYY-MM-DD HH:mm:ss.SSSZZ') : false
                let statusColor = 'default'

                if (status === 'working') statusColor = 'info'

                if (status === 'completed') statusColor = 'success'

                let late = deadline ? moment().isAfter(deadline) : false

                if (late && status !== 'completed') statusColor = 'error'

                let hasNote = !!task.getIn(['data', 'notes'], '').trim() && task.getIn(['data', 'notes']) !== '<p></p>'

                let title = (
                  <span>
                    {task.getIn(['data', '_task', 'icon']) ? (
                      <Icon name={task.getIn(['data', '_task', 'icon'])} />
                    ) : null}
                    {task.getIn(['data', 'subject']) || task.getIn(['data', '_task', 'name']) || '(Ei asetettu)'}
                  </span>
                )

                return (
                  <Table.Row key={id} error={statusColor === 'error'}>
                    <Table.Cell>
                      <span className={`status status--${statusColor}`} />
                      {viewOnly ? (
                        title
                      ) : (
                        <button className="button-plain" onClick={e => e.preventDefault() & editTask(id)}>
                          {title}
                        </button>
                      )}
                      {hasNote && (
                        <span className="tags" style={{ marginLeft: '6px' }}>
                          <span className="tags-item tags-item--blue tags-item--icon" style={{ padding: '0 6px' }}>
                            <Icon name="file" />
                          </span>
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell>{task.get('user.name', task.getIn(['user', 'name']))}</Table.Cell>
                    <Table.Cell>
                      {deadline ? (
                        <span>
                          {deadline.format('DD.MM.YYYY - HH:mm')}{' '}
                          {task.getIn(['data', 'duration']) ? (
                            <span>Kesto {task.getIn(['data', 'duration'])}</span>
                          ) : null}
                        </span>
                      ) : (
                        <span>(Ei asetettu)</span>
                      )}
                    </Table.Cell>
                    <Table.Cell>{statusLabels[task.get('status')] || task.get('status')}</Table.Cell>
                  </Table.Row>
                )
              })
            ) : (
              <Table.Row>
                <Table.Cell colSpan="4">Tehtäviä ei ole luotu.</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
          {!viewOnly ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="6" textAlign="left">
                  <button className="button-plain" onClick={e => e.preventDefault() & addTask()}>
                    Lisää tehtävä
                  </button>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : null}
        </Table>
        {viewOnly ? null : editingTask ? (
          <TaskEdit project={project} interview={interview} task={editingTask} onClose={() => editTask(false)} />
        ) : adding ? (
          <TaskAdd project={project} interview={interview} onClose={() => addTask(false)} />
        ) : null}
      </SubeditorArea>
    )
  }
}

function mapStateToProps(state) {
  return {
    adding: state.projectTaskAdding,
    editing: state.projectTaskEditing,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateTask: (projectId, interviewId, taskId, values) =>
      dispatch(updateTask(projectId, interviewId, taskId, values)),
    addTask: (add = true) => dispatch({ type: 'PROJECT_ADD_TASK', add }),
    editTask: id => dispatch({ type: 'PROJECT_EDIT_TASK', id }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectEditorTasks)
